export const BREAKPOINTS = {
    MOBILE: '576px',
    TABLET: '768px',
    SMALL_DESKTOP: '980px',
    DESKTOP: '1024px',
};
